const FooterComponent = () => {
  return (
    <div className="h-8 items-center mb-1 flex drop-shadow-lg justify-center bg-orange-400 ">
      <p>
        Made with ❣️ by{" "}
        <a href="https://www.linkedin.com/in/aniket-kasale/">Aniket Kasale</a>
      </p>
    </div>
  );
};

export default FooterComponent;
